export default {
      id: "icon-youtube-usage",
      viewBox: "0 0 46 46",
      url: "../icon/" + "icons.svg#icon-youtube-usage",
      toString: function () {
        return this.url;
      }
    }